import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { SectionDivider } from '../components/SectionDivider';
import { ProductSection } from '../components/ProductSection';
import { AboutSection } from '../components/AboutSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { IdentitySection } from '../components/IdentitySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-566" data-mp="3alb2gczudg2k">
      <HeroSection data-id="element-567" data-mp="35rp13gz4oym2" />
      <StorySection data-id="element-568" data-mp="35r6tjo70mxyu" />
      <PainSection data-id="element-569" data-mp="30tdq32x3ki29" />
      <MechanismSection data-id="element-570" data-mp="30uylsvv5e71p" />
      <SectionDivider data-id="element-571" data-mp="30ugijfa2iska" />
      <AboutSection data-id="element-572" data-mp="30rkfxdn9zfpi" />
      <ProductSection data-id="element-573" data-mp="2vv3uir7gnfg4" />
      <TestimonialsSection data-id="element-574" data-mp="2vvvf76zirsrm" />
      <OfferSection data-id="element-575" data-mp="2vwnbyl4urwjh" />
      <GuaranteeSection data-id="element-576" data-mp="2vszh9ino9436" />
      <UrgencySection data-id="element-577" data-mp="3tj47bku1002l" />
      <ObjectionsSection data-id="element-578" data-mp="3thjbzszw0d3o" />
      <IdentitySection data-id="element-579" data-mp="3tht1zgkxmk9d" />
      <FinalCTASection data-id="element-580" data-mp="3ojhtpaaacht9" />
      <Footer data-id="element-581" data-mp="3oizqtut4b5cd" />
      <RecentPurchaseToast data-id="element-582" data-mp="3okj6pkav3edm" />
    </div>;
}